<template>
	<div class="homePage-jidi">
		<el-row :gutter="40">
			<el-col :span="8">
				<el-card shadow="never">
					<div class='title'>
						<div class="en">NEWS</div>
						<el-image src='/img/基地动态.png' draggable="false"></el-image>
						<span class="ch">基地动态</span>
						<el-button type="text" style="float: right; padding: 3px 0" @click="goNews('news')"><el-image src='/img/more.png' draggable="false"></el-image></el-button>
					</div>

					<div v-for="item in newsList" :key="item.id" class="item-dongtai">
						<el-row>
							<el-col :span="4">
								<div class="dd">{{item.dd}}</div>
								<div class="yymm">{{item.yymm}}</div>
							</el-col>
							<el-col :span="20">
								<div class="item-title" :title='item.title' @click="openNews(item)">
									{{item.title}}
								</div>
								<div class="item-info" :title='item.info'>
									{{item.info}}
								</div>
							</el-col>
						</el-row>
					</div>
				</el-card>
			</el-col>
			<el-col :span="8">
				<el-card shadow="never">
					<div class='title'>
						<div class="en">INTRODUCTION</div>
						<el-image src='/img/基地简介.png' draggable="false"></el-image>
						<span class="ch">基地简介</span>
					</div>
					<div class="item-text">
						<div class="text">
							四川城市职业学院是四川省高水平高等职业学校培育单位，所依托智慧健康养老服务与管理专业群是四川省唯一获批立项的公共服务类高水平专业群。学校先后获国家级教学成果奖一等奖1项、省级教学成果特等奖2项，立项职业教育国家在线精品课程2门，十四五职业教育国家规划教材1部，教师获全国教师教学能力大赛国赛二等奖1项、三等奖2项，学生获全国职业院校养老服务技能大赛一等奖1项。
							<p>
								专业群建有完善的医学康养实训中心，拥有55 个专业实验实训室、3 个技术创新实验室、1个智慧养老虚拟仿真实训基地，建筑面积12000平方米，可开展养老照护、康复护理、心理咨询、活动组织、创新创业等一系列专业实训实践。
							</p>
						</div>
						<div>
							<el-button type="text" style="float: right; padding: 3px 0" @click="goNews('introduction')"><el-image src='/img/more.png' draggable="false"></el-image></el-button>
						</div>
					</div>
				</el-card>
			</el-col>
			<el-col :span="8">
				<el-card shadow="never">
					<div class='title'>
						<div class="en">VIDEO</div>
						<el-image src='/img/基地视频.png' draggable="false"></el-image>
						<span class="ch">基地视频</span>
					</div>
					<div class="item-video">
						<video src="/file/jidi.mp4" controls></video>
					</div>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import news from '@/assets/news.js'

	export default {
		data() {
			return {
				newsList: []
			}
		},
		created() {
			news.reverse()
			this.newsList = news.slice(0, 3)
		},
		methods: {
			goNews(val) {
				this.$emit('setDefaultactive', 'baseSituation')
				this.$router.push({
					path: 'baseSituation',
					query: {
						name: val
					}
				})
			},
			openNews(val) {
				this.$emit('setDefaultactive', 'baseSituation')

				this.$router.push({
					path: 'baseSituation',
					query: {
						name: 'news',
						id: val.id
					}
				})
			}
		}
	}
</script>

<style lang="scss">
	.homePage-jidi {
		margin: 0 auto;
		width: 1440px;
		padding: 65px 0;

		.el-card {
			border: 0;

			.el-card__body {
				padding: 0;

				.title {
					background-image: url('/img/标题栏.png');
					background-repeat: no-repeat;
					background-position: left bottom;
					height: 90px;

					.en {
						font-size: 36px;
						color: #D9D3D3;
						padding-bottom: 10px;
					}

					.ch {
						vertical-align: top;
						margin-left: 10px;
						font-size: 20px;
					}
				}

				.item-text {
					padding: 20px 0;
					font-size: 14px;
					color: #969393;
					line-height: 22px;

					.text {
						height: 230px;
						text-indent: 2em;
					}
				}

				.item-video {
					height: 250px;
					width: 440px;
					padding: 20px 0;

					video {
						width: 100%;
						height: 100%;
					}
				}

				.item-dongtai {
					border-bottom: 1px solid #d0cccc;
					padding: 10px 0;

					.yymm {
						text-align: center;
						font-size: 14px;
						color: #888888;
					}

					.dd {
						font-size: 38px;
						color: #333333;
						text-align: center;
					}

					.item-title {
						font-size: 18px;
						font-weight: 700;
						line-height: 40px;
						cursor: pointer;


						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;

					}

					.item-info {
						font-size: 14px;
						color: #666666;

						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					}
				}
			}
		}

	}
</style>